import React from 'react';
import { IIconProps } from '../interfaces';

const AleaCheckIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '19',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 33 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Häkchen groß">
      <path
        id="Vector"
        d="M1.07812 14.0527L9.97286 22.9475"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_2"
        d="M9.97656 22.9475L31.1871 1.05273"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default AleaCheckIcon;
